import { ZONE_PALETTE } from './zone-colors'

/**
 * Maps a zone to a color by its first-seen index, wrapping the shared
 * `ZONE_PALETTE` (the same palette the draw-tool editor uses). Used by the map
 * render (`PlanAssetLayer`) and the inspector so a zone's swatch matches its
 * fill on the map.
 */
export const planZoneColor = (index: number): string => ZONE_PALETTE[index % ZONE_PALETTE.length]

/**
 * Assigns each prescription feature a zone index by its rate signature, in
 * first-seen order. Shared by the map render and the inspector so a feature
 * maps to the same zone (hence the same `planZoneColor`) in both.
 */
export const assignZoneIndices = (features: readonly { properties: unknown }[]): number[] => {
  const indexBySignature = new Map<string, number>()
  return features.map((f) => {
    const signature = JSON.stringify(f.properties)
    const index = indexBySignature.get(signature) ?? indexBySignature.size
    indexBySignature.set(signature, index)
    return index
  })
}

/**
 * Colors for drawing plan assets. An inverted boundary marks an excluded area,
 * so it takes amber rather than reading as part of the field.
 */
export const PLAN_ASSET_STYLE = {
  BOUNDARY: {
    FILL: 'rgb(0, 186, 143)',
    STROKE: 'rgb(0, 24, 18)'
  },
  INVERTED_BOUNDARY: {
    FILL: 'rgba(245, 158, 11, 0.5)',
    STROKE: 'rgb(120, 53, 15)'
  },
  ZONE_STROKE: 'rgba(0, 0, 0, 0.6)'
} as const
